import React from "react";
import { RequestSettings } from "./types";
import { protectedResources } from "../app/authConfig";
import { getAllUserRoles } from "../pages/user-management/components/constants";
import useUserRole from "./useUserRole";
import { UserRole } from "../utils";

const useRequestApprovedUsers = (): [RequestSettings, (settings: Partial<RequestSettings>) => void] => {
  const isGlobalAdmin = useUserRole() === UserRole.GlobalAdmin;
  const [reqRequests, setReqRequest] = React.useState<RequestSettings>({
    PageNumber: 1,
    SearchText: "",
    Name: "",
    PerformanceType: "",
    SortOrder: 1,
    PageSize: 12,
    OrderBy: "JobTitle",
    ParameterOne: "Approved",
    ParameterTwo: getAllUserRoles(isGlobalAdmin),
    ParameterThree: "Active,Inactive,Pending",
    url: process.env.REACT_APP_INFINITYS_API || "", 
    accessToken: localStorage.getItem("AccessToken") || "",
  });

  const updateSettings = (settings: Partial<RequestSettings>) => {
    setReqRequest((prevSettings) => ({ ...prevSettings, ...settings }));
  };

  return [reqRequests, updateSettings];
};

export default useRequestApprovedUsers;